import gql from 'graphql-tag';

const GET_SEGMENT_IDENTIFY_QUERY = gql`
  query PCP_SegmentIdentifyQuery($anonymousId: String, $accountId: String) {
    viewer {
      id
      segmentIdentify(accountId: $accountId, anonymousId: $anonymousId) {
        prospects
        allCustomers
      }
    }
  }
`;

export default GET_SEGMENT_IDENTIFY_QUERY;
